import React from "react";
import "./Modal.scss";
import Drawer from "@mui/material/Drawer";
import { FaEdit } from "react-icons/fa";
import CustomButton from "../Button/CustomButton";
import { googleEvent_LOJ188_no, googleEvent_LOJ188_yes } from "../../lib/google-analytics";

export default function ReferenceModal(props) {
  const { openReferenceModal, setOpenReferenceModal, values, submitReferenceDetails } = props;

  return (
    <div>
      <Drawer
        anchor="bottom"
        open={openReferenceModal["bottom"]}
        onClose={() => {
          setOpenReferenceModal({ ...openReferenceModal, bottom: false });
          googleEvent_LOJ188_no();
        }}
      >
        <div className="reference__modal">
          <h3>Are these references correct?</h3>
          <div className="reference-list">
            <div className="title">
              <h6>Reference 1</h6>
              <FaEdit
                size={18}
                color="#939393"
                onClick={() => setOpenReferenceModal({ ...openReferenceModal, bottom: false })}
              />
            </div>
            <p>{values.nameOne}</p>
            <p>+91 {values.mobileOne}</p>
          </div>

          <div className="reference-list">
            <div className="title">
              <h6>Reference 2</h6>
              <FaEdit
                size={18}
                color="#939393"
                onClick={() => setOpenReferenceModal({ ...openReferenceModal, bottom: false })}
              />
            </div>
            <p>{values.nameTwo}</p>
            <p>+91 {values.mobileTwo}</p>
          </div>

          <p>
            <strong>Note:</strong> Your provided references may be reached out to verify details in relation to your
            loan application.
          </p>

          <br />

          <CustomButton
            text="Yes, these are correct"
            onClick={() => {
              submitReferenceDetails(values);
              googleEvent_LOJ188_yes();
            }}
          />
        </div>
      </Drawer>
    </div>
  );
}
